import React from "react";
import { InfoPanelContainer, CustomTitle, ChildrenContainer } from "./InfoPanel.styles";
import { useTheme } from "@mui/material/styles";

export interface CustomInfoPanelProps {
    title?: string | React.ReactElement;
    centered?: boolean;
    children?: React.ReactNode;
    id?: string;
}

export const InfoPanel = ({
    title,
    children,
    centered,
    id,
    ...rest
}: CustomInfoPanelProps) => {
    const theme = useTheme();

    return (
        <InfoPanelContainer id={id}>
            <CustomTitle
                sx={{
                    textAlign: centered ? "center" : "inherit"
                }}
                {...rest}>
                {title}
            </CustomTitle>
            <ChildrenContainer>
                {children}
            </ChildrenContainer>
        </InfoPanelContainer>
    );
};

export interface InfoPanelProps extends React.ComponentProps<typeof InfoPanel> {
    as?: React.ElementType;
}

InfoPanel.displayName = "InfoPanel";